import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageTitle from '../components/PageTitle';

const Products = () => {
  const hosieryProducts = [
    { name: "Socks", image: "/product-placeholder.jpg" },
    { name: "Stockings", image: "/product-placeholder.jpg" },
    { name: "Tights / Pantyhose", image: "/product-placeholder.jpg" },
    { name: "Leggings", image: "/product-placeholder.jpg" },
    { name: "Knee-Highs & Thigh-Highs", image: "/product-placeholder.jpg" },
    { name: "Compression Wear", image: "/product-placeholder.jpg" },
    { name: "Baby & Kids Hosiery", image: "/product-placeholder.jpg" },
    { name: "Specialty Hosiery", image: "/product-placeholder.jpg" }
  ];

  // Toggle white text on scroll (black at top) like About/Services
  useEffect(() => {
    const handleScroll = () => {
      const productsNav = document.getElementById('products-nav');
      if (!productsNav) return;
      if (window.scrollY > 0) {
        productsNav.classList.add('scrolled');
      } else {
        productsNav.classList.remove('scrolled');
      }
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="pt-20" style={{ backgroundColor: '#F2F0E6' }}>
      <PageTitle title="Products" />
      {/* Local navbar wrapper for Products page */}
      <div id="products-nav" className="relative z-50">
        <Navbar />
      </div>

      {/* Hero Section */}
      <section
        className="relative min-h-[33vh] flex flex-col"
        style={{ backgroundColor: '#F2F0E6' }}
      >
        <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8">
          <div className="w-full max-w-5xl">
            <h1
              style={{
                fontFamily: 'Belleza, serif',
                fontWeight: 400,
                fontStyle: 'normal',
                fontSize: '64px',
                lineHeight: '70px',
                letterSpacing: '0%',
                textAlign: 'center',
                textTransform: 'capitalize',
                color: '#272525'
              }}
            >
              Products
            </h1>
            <p
              className="mt-4"
              style={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 400,
                fontStyle: 'normal',
                fontSize: '16px',
                lineHeight: '100%',
                letterSpacing: '0%',
                textAlign: 'center',
                color: '#272525'
              }}
            >
              We provide tailored solutions for a wide range of industries, ensuring quality, performance, and reliability for every application.
            </p>
          </div>
        </div>
        </section>

      {/* Image Categories Section */}
      <section className="py-16" style={{ backgroundColor: '#FFFFFF' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10 justify-items-center">
            {[
              {
                img: '/home interior.jpg',
                title: 'Home & Interior Yarns',
                text:
                  'Yarns for upholstery, curtains, decorative fabrics, and durable home textiles. Emphasis on color fastness, strength, and easy care.'
              },
              {
                img: '/WhatsApp Image 2025-10-01 at 12.45.19 (1).jpeg',
                title: 'Apparel Yarns',
                text:
                  'Yarns designed for men’s suiting, casual wear, and fashion fabrics – mainly polyester, viscose, modal, and tencel blends. Focused on drape, comfort, and performance'
              },
              {
                img: '/WhatsApp Image 2025-10-01 at 12.45.19 (2).jpeg',
                title: 'Technical & Industrial Yarns',
                text:
                  'Special-purpose yarns for workwear, uniforms, automotive textiles, filtration fabrics, and other performance-driven applications.'
              },
              {
                img: '/WhatsApp Image 2025-10-01 at 12.45.19.jpeg',
                title: 'Specialty Yarns',
                text:
                  'Dope-dyed, ring spun, mélange, or value-added yarns with unique finishes, textures, and sustainable options.'
              }
            ].map((item, idx) => (
              <div key={idx} className="product-card">
                {/* Heading above the image */}
                <h3
                  className={`product-title ${idx > 0 ? 'pt-mobile' : ''}`}
                  style={{
                    fontFamily: 'Belleza, serif',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontSize: '40px',
                    lineHeight: '45px',
                    letterSpacing: '0%',
                    textAlign: 'center',
                    textTransform: 'capitalize',
                    color: '#272525',
                    marginBottom: '20px'
                  }}
                >
                  {item.title}
                </h3>
                
                {/* Image container with hover effects */}
                <div className="product-image-container">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="product-image"
                    style={{
                      width: '546px',
                      height: '497px',
                      borderRadius: '12px',
                      objectFit: 'cover',
                      transition: 'all 0.4s ease-in-out'
                    }}
                  />
                  
                  {/* Overlay text that emerges on hover */}
                  <div className="product-overlay">
                    <div className="product-text-content">
                      <p
                        className="product-description"
                        style={{
                          fontFamily: 'Poppins, sans-serif',
                          fontWeight: 400,
                          fontStyle: 'normal',
                          fontSize: '16px',
                          lineHeight: '150%',
                          letterSpacing: '0%',
                          textAlign: 'center',
                          color: '#272525',
                          margin: 0,
                          padding: '20px'
                        }}
                      >
                        {item.text}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />

      {/* Local CSS overrides for Navbar (Products page only) */}
      <style jsx>{`
        /* Keep navbar elements above content */
        #products-nav nav { position: relative; z-index: 50; }
        #products-nav img[alt="HIK"] { 
          margin-top: 0.5rem !important; 
          position: relative; 
          z-index: 50; 
        }

        @media (min-width: 768px) {
          #products-nav img[alt="HIK"] { 
            margin-top: 1rem !important; 
          }
        }

        /* Default at top of page: black navbar links/buttons */
        #products-nav .md\\:flex a,
        #products-nav .md\\:flex button {
          margin-top: 0.5rem !important;
          color: #272525 !important;
          font-family: Belleza, serif !important;
          font-weight: 400 !important;
          font-size: 20px !important;
          line-height: 100% !important;
        }

        /* Button alignment tweak to match left items */
        #products-nav .md\\:flex button {
          padding-top: 0.375rem !important;
          padding-bottom: 0.375rem !important;
          position: relative; 
          top: -4px;
        }

        /* When scrolled: turn navbar text white */
        #products-nav.scrolled .md\\:flex a,
        #products-nav.scrolled .md\\:flex button {
          color: #ffffff !important;
        }

        /* Product card animations */
        .product-card {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 546px;
        }

        .product-image-container {
          position: relative;
          width: 546px;
          height: 497px;
          border-radius: 12px;
          overflow: hidden;
          cursor: pointer;
        }

        .product-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: all 0.4s ease-in-out;
        }

        .product-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: transparent;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transform: translateY(20px);
          transition: all 0.4s ease-in-out;
          border-radius: 12px;
        }

        .product-text-content {
          text-align: center;
          max-width: 90%;
        }

        .product-description {
          transform: translateY(10px);
          transition: transform 0.4s ease-in-out 0.1s;
        }

        /* Hover effects */
        .product-image-container:hover .product-image {
          opacity: 0.3;
          transform: scale(1.05);
        }

        .product-image-container:hover .product-overlay {
          opacity: 1;
          transform: translateY(0);
        }

        .product-image-container:hover .product-description {
          transform: translateY(0);
        }

        /* Make cards responsive on small screens */
        @media (max-width: 640px) {
          .product-card { 
            width: 100%; 
            max-width: 400px;
          }
          .product-image-container { 
            width: 100%; 
            height: 300px; 
          }
          .product-title {
            font-size: 28px !important;
            line-height: 32px !important;
          }
          .pt-mobile {
            padding-top: 32px;
          }
        }
      `}</style>
    </div>
  );
};

export default Products;